import { createSlice, Tuple } from "@reduxjs/toolkit";

export const initialState = {
  botList: [],
  message: null,
  loading: false,
  success: false,
  error: false,
  currentPage:0,
  total_pages:0,
  Inserted_Values:null,
  Insertion_Query:null,
  insert_table:null,
  searchable_column:null
};

const bot_List_Slice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    fetch_Bot_List_Successful(state, action) {
      state.botList = action.payload.data;
      state.loading = false;
      state.success = true;
      state.bot_list_Error = null;
      state.currentPage = action.payload.current_page
      state.total_pages= action.payload.total_pages
    },
    fetch_Bot_List_Failed(state, action) {
    
      state.botList = [];
      state.loading = false;
      state.bot_list_Error = action.payload;
      state.error = true;
    },
    reset_bot_list_Change(state) {
      state.botList=[]
      state.success = false;
      state.error = false;
      state.currentPage = 0
    },
     change_page_bot_list(state, action) {
      state.currentPage=action.payload
     },
    start_loader_bot_list(state) {
      state.loading = true;
    },
    set_insert_values(state,action){
      const { Inserted_Values,Insertion_Query,insert_table,searchable_column } = action.payload
        state.Inserted_Values=Inserted_Values,
        state.Insertion_Query=Insertion_Query,
        state.insert_table=insert_table,
        state.searchable_column=searchable_column
    }
  }
});

export const {
  fetch_Bot_List_Successful,
  fetch_Bot_List_Failed,
  reset_bot_list_Change,
  start_loader_bot_list,
  set_insert_values
} = bot_List_Slice.actions;

export default bot_List_Slice.reducer;